import { enumToSelectorOptions } from '@libs/helpers';
import { SlidePreset } from './slide-preset.enum';

export const SlidePresetOptions = enumToSelectorOptions(SlidePreset);
